// extracted by mini-css-extract-plugin
export default {"chartContainer":"SalesChart_chartContainer__mXsYy"};